// Constantes des sections pour l'onboarding pour éviter les dépendances entre UI et logique métier
export const SECTION_DASHBOARD = 'dashboard';
export const SECTION_CALENDAR = 'calendar';
export const SECTION_RESERVATION = 'reservation';
export const SECTION_AVAILABILITY = 'availability';
export const SECTION_SERVICES = 'services';
export const SECTION_PROFILE = 'profile';
